var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshot1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 1.14551H3.4286C2.16624 1.14551 1.14289 2.16886 1.14289 3.43122V28.5741C1.14289 29.8365 2.16624 30.8598 3.4286 30.8598H24C25.2624 30.8598 26.2857 29.8365 26.2857 28.5741V18.2884M1.14289 24.0026H26.2857M8.00003 6.85979H12.5715M8.00003 12.5741H10.2857M20.5581 17.1588L13.7009 18.3931L14.8438 11.4445L24.5123 1.82162C24.7248 1.60738 24.9776 1.43734 25.2563 1.3213C25.5347 1.20525 25.8334 1.14551 26.1351 1.14551C26.4371 1.14551 26.7358 1.20525 27.0142 1.3213C27.2928 1.43734 27.5456 1.60738 27.758 1.82162L30.1808 4.24448C30.3952 4.45696 30.5653 4.70976 30.6812 4.9883C30.7973 5.26683 30.8569 5.5656 30.8569 5.86734C30.8569 6.16907 30.7973 6.46784 30.6812 6.74635C30.5653 7.02489 30.3952 7.27771 30.1808 7.49019L20.5581 17.1588Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot1);
export default __webpack_public_path__ + "static/media/snapshot1.ce243c4f8d10055eb0738195db827600.svg";
export { ForwardRef as ReactComponent };